<template>
  <div class="d-flex full-width" v-bind="attrs" v-on="on">
    <v-tooltip v-if="contentName" bottom>
      <template #activator="{ on: onToolTip, attrs: attrsToolTip }">
        <v-icon
          v-bind="attrsToolTip"
          class="pr-1"
          :color="iconColor"
          size="18"
          v-on="onToolTip"
        >
          {{ icon }}
        </v-icon>
      </template>
      <span>{{ contentName }}</span>
    </v-tooltip>
    <v-icon
      v-else-if="icon"
      class="pr-1"
      :color="iconColor"
      size="18"
    >
      {{ icon }}
    </v-icon>
    <span> {{ sessionName }} </span>
  </div>
</template>
<script>

export default ({
  props: {
    sessionName: {
      type: String,
      default: ''
    },
    contentName: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    attrs: Object,
    on: [Function, Object],
    iconColor: {
      type: String,
      default: 'white'
    }
  }

});
</script>
